import { Component } from '@angular/core';
import { hotCallDetails } from '../../common/models/hotCall.model';
import { HotCallStatusService } from '../../common/services/hot-call-status.service';
import { FilterService } from '../../common/services/filter.service'
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { GET_ACTIVEHOTCALL } from '../../common/graphql/queries';
import { DatePipe } from '@angular/common';
import { userApplConfigSignal } from 'src/app/common/signals/user-profile-signal';

@Component({
  selector: 'app-active-hot-calls',
  templateUrl: './active-hot-calls.component.html',
  styleUrls: ['./active-hot-calls.component.css'],
  providers: [DatePipe]
})
export class ActiveHotCallsComponent {
  activeHotcallForm: FormGroup;
  hotCallDetails : hotCallDetails;
  statusClass : string = "";
  isLoading: boolean = false;
  errorMessage: string = '';
  sortState: 'normal' | 'asc' | 'desc' = 'normal';
  public activeHotCalls: hotCallDetails[] = [];
  public filteredHotCalls: hotCallDetails[] = [];
  constructor(
    private readonly fb: FormBuilder,
    private readonly hotCallStatusService: HotCallStatusService,
    private readonly filterService: FilterService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly commonsService: CommonserviceService,
    private readonly datePipe: DatePipe,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ) {
    translate.setDefaultLang('en');
  }

  public searchQuery: string = '';
  private readonly searchSubject = new Subject<string>();
  public selectedStatus: string = '';
  public statusOptions: string[] = [];

  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.activeHotCalls = [];
    this.filteredHotCalls = [];
    this.spinner.show();
    const plantName = userApplConfigSignal().plantName;
    const shopName = userApplConfigSignal().shopName;
    const lineName = userApplConfigSignal().lineName;

    this.commonsService.getHcmData(GET_ACTIVEHOTCALL , {plantName, shopName, lineName}).subscribe({
      next: (response) => {
      if (response?.data?.getActiveHotCalls?.length) {
        this.activeHotCalls  = response.data.getActiveHotCalls;
        this.statusOptions = [...new Set(this.activeHotCalls.map(t => t.ticketStatus))];
        this.filteredHotCalls = this.activeHotCalls;
        this.statusClass = this.hotCallStatusService.getHotCallStatus(this.activeHotCalls[0]?.ticketStatus);
        this.hotCallDetails = this.activeHotCalls[0];
      } else {
        this.activeHotCalls = [];
        this.filteredHotCalls = [];
        this.spinner.hide();
      }
      if(response?.errors){
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      }
      },

      error: (error) => {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }

    }
   );

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.filterHotCalls(searchTerm, this.selectedStatus);
    });
    this.activeHotcallForm = this.fb.group({
       searchQuery: ['',],
       selectedStatus: ['',],
    });
    this.activeHotcallForm.valueChanges.subscribe(values => {
      this.filteredHotCalls = this.filterService.filterHotCalls(values.searchQuery, values.selectedStatus, this.activeHotCalls)
    });
  }

  public filterHotCalls(searchTerm: string, status: string): void {
    this.filteredHotCalls = this.filterService.filterHotCalls(searchTerm, status, this.activeHotCalls);
  }

  public selectHotCall(hotCallLineData: hotCallDetails) : void {
    this.statusClass = this.hotCallStatusService.getHotCallStatus(hotCallLineData.ticketStatus)
    this.hotCallDetails = hotCallLineData;
  }

  public getHotCallStatus(status : string) : string {
    return this.hotCallStatusService.getHotCallStatus(status);
  }

  public backToHome(): void {
    this.router.navigateByUrl('home')
  }

  public toggleSortOrder(): void {
    const result = this.filterService.toggleSortOrder(this.filteredHotCalls, this.sortState);
    this.filteredHotCalls = result.sortedData;
    this.sortState = result.sortState;
  }
  public getStatus(ticketStatus : string): string{
    return this.hotCallStatusService.getHotCallStatusByCode(ticketStatus);
  }
}